<template>
    <div class="card">
        <h5>{{ $t('menu.payBets') }}</h5>
        <BetsOperations :operationType="'pay'"></BetsOperations>
    </div>
</template>
<script>
import BetsOperations from './Components/BetsOperations.vue';
export default {
    name: 'rouletteTickets',
    components: {
        BetsOperations,
    },
    data() {
        return {};
    },
};
</script>